/**
 * Catalogue de contenu français pour la fonctionnalité Books & Rules / campaign
 * (`@gamecodex/world-ui` → `features/books`).
 *
 * Les clés reflètent les appels `t('books.*')` dans les composants React de la fonctionnalité. Les valeurs
 * sont les chaînes françaises exactes traduites du catalogue anglais original.
 */
export const booksFr = {
  // BackerDownloadModal.tsx
  'books.backerModal.title': 'Réclame Ton PDF Contributeur',
  'books.backerModal.sendLinkError': 'Nous n\'avons pas pu envoyer ton lien de connexion en ce moment. Réessaye bientôt.',
  'books.backerModal.checkInboxPrefix': 'Vérifie ta boîte de réception à',
  'books.backerModal.checkInboxSuffix':
    'Si tu as contribué avec cet email, un lien de connexion est en chemin — clique dessus pour réclamer ta copie.',
  'books.backerModal.linkAutoSignIn': 'Le lien s\'ouvre sur ce site et te connecte automatiquement. Aucun mot de passe nécessaire.',
  'books.backerModal.signInIntro':
    'Saisis l\'email avec lequel tu as contribué. Nous t\'enverrons un lien de connexion en un clic, puis préparerons ta copie personnelle.',
  'books.backerModal.pledgeEmailLabel': 'Email du compte contributeur',
  'books.backerModal.emailLinkCta': 'M\'envoyer un lien de connexion',
  'books.backerModal.prepareTimeout':
    'Ta copie prend plus de temps que prévu à préparer. Réessaye dans quelques minutes.',
  'books.backerModal.notEntitled': 'Tu es connecté, mais ta contribution ne comprend pas ce livre.',
  'books.backerModal.notClaimable': 'Ce livre n\'est pas proposé en téléchargement contributeur.',
  'books.backerModal.prepareError': 'Nous n\'avons pas pu préparer ton téléchargement en ce moment. Réessaye bientôt.',
  'books.backerModal.signedInAs': 'Connecté en tant que',
  'books.backerModal.signOut': 'Se déconnecter',
  'books.backerModal.verified': 'Vérifié',
  'books.backerModal.welcomeBack': ' — bienvenue,',
  'books.backerModal.backerNumber': '(Contributeur #{number})',
  'books.backerModal.copyReady':
    'Ta copie personnelle est prête. Ce lien est personnel et expire bientôt — ne le partage pas.',
  'books.backerModal.downloadPdf': 'Télécharge ton PDF',
  'books.backerModal.dtrpgEmailLabel': 'Email du compte DriveThruRPG',
  'books.backerModal.optional': '(facultatif)',
  'books.backerModal.dtrpgWarn':
    'Ajoute-le aussi pour dupliquer l\'achat dans ta bibliothèque DriveThruRPG. Saute cette étape et ta copie reste téléchargeable ici.',
  'books.backerModal.preparingCopy': 'Préparation de ta copie…',
  'books.backerModal.prepareDownload': 'Préparer & Télécharger',

  // BackerVerifyPage.tsx
  'books.backerVerify.missingToken': 'Ce lien de connexion n\'a pas son jeton. Demande un nouveau lien depuis la page du livre.',
  'books.backerVerify.invalidToken':
    'Ce lien de connexion est invalide ou a expiré. Demande-en un nouveau depuis la page du livre.',
  'books.backerVerify.seoTitle': 'Connexion contributeur',
  'books.backerVerify.seoDescription': 'Vérification de ton lien de connexion contributeur Grymwyrd.',
  'books.backerVerify.confirming': 'Confirmation de ta connexion contributeur…',
  'books.backerVerify.signedInHeading': 'Tu es connecté',
  'books.backerVerify.signedInAs': 'Connecté en tant que',
  'books.backerVerify.headBackPrefix': 'Retourne au livre et clique sur',
  'books.backerVerify.downloadWord': 'Télécharger',
  'books.backerVerify.headBackSuffix': 'pour réclamer ta copie.',
  'books.backerVerify.backToBook': 'Retour à ton livre',
  'books.backerVerify.browseAthenaeum': 'Parcourir l\'Athénée',
  'books.backerVerify.problemHeading': 'Problème de lien de connexion',

  // BookCard.tsx
  'books.card.viewAria': 'Afficher {title}',
  'books.card.coverAlt': 'Couverture de {title}',
  'books.card.owned': 'Possédé',

  // BookCover.tsx
  'books.cover.coverAlt': 'Couverture de {title}',

  // BookStorePage.tsx
  'books.store.seoTitle': 'Livres & Règles',
  'books.store.seoDescription':
    'Les tomes du crépuscule éternel — manuels de base, SRD illustré et aventures grimdark. Achète pour débloquer des modules et gagne des pièces.',
  'books.store.eyebrow': 'L\'Athénée',
  'books.store.heading': 'Livres & Règles',
  'books.store.intro':
    'Acquiers les tomes qui lient le monde ensemble. Chaque achat débloque des modules jouables dans tes campagnes et te récompense avec des pièces pour l\'économie intra-monde.',
  'books.store.filterAria': 'Filtrer les livres par type',
  'books.store.filterAll': 'Tous',
  'books.store.loading': 'Ouverture des archives…',
  'books.store.empty': 'Aucun tome ne correspond à cette catégorie pour le moment. Les scribes travaillent toujours.',

  // BuyButton.tsx
  'books.buy.checkoutUnavailable': 'Le paiement n\'est pas encore disponible. Réessaye bientôt.',
  'books.buy.signInToClaim': 'Connecte-toi pour réclamer ce tome.',
  'books.buy.ledgerSealed': 'Le registre du marchand est scellé pour le moment — le paiement arrive bientôt.',
  'books.buy.inLibrary': 'Dans Ta Bibliothèque',
  'books.buy.openingVault': 'Ouverture de la voûte…',
  'books.buy.claimFree': 'Réclamer Gratuitement',
  'books.buy.buyPrice': 'Acheter — {price}',
  'books.buy.unlockPrefix': 'Acheter → déverrouille modules +',
  'books.buy.coinsSuffix': '{coins} pièces',

  // BookDetailPage.tsx
  'books.detail.loading': 'Feuilletage des pages…',
  'books.detail.backToAthenaeum': 'Retour à l\'Athénée',
  'books.detail.unlockOwned': 'Tu possèdes ce tome — son contenu Grymwyrd est déverrouillé dans l\'encyclopédie.',
  'books.detail.unlockClaim': 'Réclame ce tome pour déverrouiller son contenu Grymwyrd dans l\'encyclopédie.',
  'books.detail.returnTo': 'Retour à {label}',
  'books.detail.backerCta': 'Contributeur ? Télécharge ton PDF',
  'books.detail.coinsEarned': 'Tu as gagné {coins} pièces de cet achat.',
  'books.detail.coinsGranted': 'L\'achat accorde {coins} pièces à ton trésor.',
  'books.detail.byAuthor': 'Par {author}',
  'books.detail.statPrice': 'Prix',
  'books.detail.statPages': 'Pages (dernier rendu)',
  'books.detail.statWords': 'Mots (dernier rendu)',
  'books.detail.ofThisTome': 'De Ce Tome',
  'books.detail.noDescription': 'Aucune description n\'a été inscrite pour ce volume pour le moment.',
  'books.detail.previewHeading': 'Aperçu',
  'books.detail.previewBlurb': 'Entrevis un échantillon de ce tome avant de le réclamer.',
  'books.detail.readPreview': 'Lire un aperçu',
  'books.detail.tocHeading': 'Table des Matières',
  'books.detail.tocEmpty': 'Le contenu de ce tome n\'a pas encore été catalogué.',
  'books.detail.pageAbbrev': 'p. {page}',
  'books.detail.unlockedHeading': 'Entrées d\'Encyclopédie Déverrouillées',
  'books.detail.unlockedOwnedNote': 'Maintenant partie de ton encyclopédie vivante :',
  'books.detail.unlockedLockedNote':
    'Achète ce tome pour inscrire ses créatures, sorts et secrets dans ton encyclopédie — et réclame',
  'books.detail.coinsAmount': '{coins} pièces',
  'books.detail.attributionsHeading': 'Attributions & Licences',
  'books.detail.attributionSource': 'Source',
  'books.detail.attributionLink': 'lien',

  // CampaignLandingPage.tsx
  'books.campaign.liveCampaign': 'Campagne en Cours',
  'books.campaign.backThisProject': 'Soutenir Ce Projet',
  'books.campaign.viewStretchGoals': 'Voir les Défis Supplémentaires',
  'books.campaign.pledged': 'Promis',
  'books.campaign.backers': 'Contributeurs',
  'books.campaign.pitchHeading': 'Le Pitch',
  'books.campaign.backerUnlockedHeading': 'Entrées Déverrouillées par Contributeurs',
  'books.campaign.backerUnlockedBlurb':
    'Les contributeurs ont accès anticipé au contenu qui s\'écoule directement dans l\'encyclopédie vivante. Voici un avant-goût de ce qui est déjà canon :',
  'books.campaign.previewsEmpty': 'Un nouveau canon est inscrit — reviens à mesure que les défis se déverrouillent.',
  'books.campaign.choosePledge': 'Choisis Ton Engagement',
  'books.campaign.mostBacked': 'Plus Soutenu',
  'books.campaign.pledgeAmount': 'Engager {amount}',
  'books.campaign.pledgeFooter':
    'Les engagements sont traités de façon sécurisée au paiement. Les récompenses de contribution (pièces, modules et déverrouillages d\'encyclopédie) sont accordées à ton compte Grymwyrd une fois que le service de campagne sera en ligne.',

  // LanguageSelect.tsx
  'books.language.label': 'Langue',

  // PreviewModal.tsx
  'books.preview.title': 'Aperçu — {title}',
  'books.preview.pdfAria': 'Aperçu PDF de {title}',
  'books.preview.cannotDisplay': 'Ton navigateur ne peut pas afficher l\'aperçu en ligne.',
  'books.preview.openNewTab': 'Ouvrir l\'aperçu dans un nouvel onglet',
  'books.preview.preparingHeading': 'L\'aperçu est en cours de préparation.',
  'books.preview.preparingBody':
    'Un échantillon de ce tome est inscrit par le scriptorium et apparaîtra ici bientôt. En attendant, jette un coup d\'œil à ce qui se trouve à l\'intérieur :',
  'books.preview.excerptLabel': 'Extrait — {title}',
  'books.preview.excerptFallback':
    'Au-delà de ce seuil gisent des pages imbibées de terreur et de merveille. Acquiers le tome pour lire la suite.',
  'books.preview.noExcerpt': 'Aucun extrait n\'a été catalogué pour ce volume pour le moment.',

  // RulesPage.tsx
  'books.rules.sectionSpells': 'Sorts',
  'books.rules.sectionMonsters': 'Créatures',
  'books.rules.sectionMagicItems': 'Objets Magiques',
  'books.rules.sectionWeapons': 'Armes',
  'books.rules.sectionArmor': 'Armures',
  'books.rules.sectionSkills': 'Compétences',
  'books.rules.entriesCount': '{entries} entrées',
  'books.rules.readingLabel': 'Lecture de {label}…',
  'books.rules.noneCatalogued': 'Aucun {label} catalogué dans ce système pour le moment.',
  'books.rules.browseAll': 'Parcourir tous les {label} dans l\'encyclopédie →',
  'books.rules.seoTitle': 'Règles & SRD',
  'books.rules.seoDescription':
    'Parcourir le Document de Référence du Système — sorts, créatures, objets et règles qui lient le crépuscule éternel. SRD 5e maintenant, avec plus de systèmes à venir.',
  'books.rules.eyebrow': 'Le Codex',
  'books.rules.heading': 'Règles & Référence Système',
  'books.rules.intro':
    'Le contenu de jeu ouvert qui alimente Grymwyrd. Parcourir les entrées pertinentes aux règles et plonge dans l\'encyclopédie complète pour les blocs de stats et le contenu. Grymwyrd est fourni avec le SRD 5e aujourd\'hui — PF2e et d\'autres systèmes arrivent.',
  'books.rules.loading': 'Consultation du codex…',
  'books.rules.gameSystems': 'Systèmes de Jeu',
  'books.rules.noSystems': 'Aucun système de jeu n\'est enregistré pour le moment.',
  'books.rules.openSrd': 'Ouvrir SRD',
  'books.rules.lockedComingSoon': 'Verrouillé — à venir',
  'books.rules.referenceContent': '{name} — Contenu de Référence',
  'books.rules.releasedUnder': 'Publié sous {license}',
  'books.rules.licenseLink': 'licence',

  // StretchGoals.tsx
  'books.stretch.goalProgressAria': 'Progression du financement de {title}',
  'books.stretch.unlockedAdded': 'Déverrouillé — ajouté à l\'encyclopédie',
  'books.stretch.percentFunded': '{pct}% financé',
  'books.stretch.autoPopulates': 'Remplit automatiquement l\'encyclopédie',
  'books.stretch.raisedSoFar': 'Montant collecté jusqu\'à présent',
  'books.stretch.backers': 'Contributeurs',
  'books.stretch.overallAria': 'Financement global de la campagne',
  'books.stretch.heading': 'Défis Supplémentaires',
} as const
